import WebFont from 'webfontloader'

WebFont.load({
  google: {
    families: ['DM Sans:300,500'],
  },
})
